module.exports = __webpack_public_path__ + "img/6.238bd955.png";